import { jsx as _jsx } from "react/jsx-runtime";
import styles from '../MyEquipment.module.scss';
import { Drawer } from '../../common';
export const MyEquipmentDrawer = ({ children, drawer, size = 'default', onCloseHandler, isChild = false }) => {
    return (_jsx(Drawer, { ...drawer.drawerProps, onBlDrawerClose: onCloseHandler, className: `${styles['drawer']}`, size: size, hideCloseButton: isChild, disableBackdropClick: isChild, children: children }));
};
